import Field from 'components/forms/field/Field';
import type { FC } from 'react';
import { PluginIconPicker } from './PluginIconPicker';

interface BasicsTabProps {
    existingPluginNames: string[];
}

export const BasicsTab: FC<BasicsTabProps> = ({ existingPluginNames }) => {
    const lowerCasedExistingPluginNames = existingPluginNames.map((name) => name.toLowerCase());

    return (
        <div className='flex gap-12 p-6 max-w-[60rem]'>
            <div className='flex flex-col flex-1'>
                <Field.Input
                    name='displayName'
                    label='Name'
                    title='Name'
                    placeholder='Enter a name'
                    validation={{
                        required: true,
                        maxLength: 128,
                        minLength: 2,
                        validate: (value: string | null) => {
                            if (value != null && lowerCasedExistingPluginNames.includes(value.toLowerCase())) {
                                return 'This name is already in use. Please choose a different name.';
                            }

                            return true;
                        }
                    }}
                />
                <Field.Input
                    name='author'
                    label='Author'
                    placeholder='Enter the author name'
                    validation={{ required: true, maxLength: 255 }}
                />
                <Field.Input
                    name='description'
                    label='Description'
                    placeholder='Enter a description'
                    validation={{ required: false, maxLength: 255 }}
                />
                <Field.Input
                    name='helpLink'
                    label='Help Link'
                    placeholder='e.g. https://docs.squaredup.com/data-sources/1password-plugin'
                    help='The URL of the help docs to show when adding the data source. Must be a valid SquaredUp docs URL, e.g. https://docs.squaredup.com/data-sources/1password-plugin'
                    validation={{
                        pattern: {
                            value: /^https:\/\/docs\.squaredup\.com/iu,
                            message: 'Must be a valid SquaredUp docs URL (must start with https://docs.squaredup.com)'
                        }
                    }}
                />
            </div>

            <div className='flex-none'>
                <Field label='Icon'>
                    <PluginIconPicker />
                </Field>
            </div>
        </div>
    );
};
